import React, { useState, useEffect } from "react";
import CalendarIcon from "./icons/CalendarIcon";
import EmptyContent from "./EmptyContent";
import Header from "./Header";
function Agenda({ event }) {
  const [days, setDays] = useState([]);

  useEffect(() => {
    if (!event.event_slug) return;
    fetch(`/api/events/${event.event_slug}/agenda/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access")}`,
      },
    })
      .then((res) => {
        if (res.status === 401 || res.status === 403) {
          window.location.href = `/events/${event.event_slug}/signin`;
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (data) setDays(data);
      });
  }, [event.event_slug]);

  const [selectedDay, setSelectedDay] = useState(null);

  useEffect(() => {
    if (days.length > 0 && selectedDay === null) {
      setSelectedDay(days[0].id);
    }
  }, [days, selectedDay]);

  const activeDay = days?.find((d) => d.id === selectedDay);

  return (
    <div>
      <Header />
      <div className="bg-gradient-to-b from-gray-200 to-0,0,0,0 mx-auto px-4 py-12">
        {days.length > 0 ? (
          <>
            <p className="mt-4 text-pretty text-gray-700 leading-relaxed px-4">
              Explore the four-day program featuring keynote sessions, expert
              insights, and interactive discussions across sustainability,
              governance, auditing, technology, and collaboration. Select each
              day to view detailed sessions and speakers.Select each day to view
              detailed sessions and speakers.
              <a
                href="/Innovation Workshop Program.pdf"
                className="font-bold ml-2"
              >
                Click on to view and download the full program.
              </a>
            </p>

            <div className="border-b border-gray-600 mt-6 px-4 overflow-x-auto lg:overflow-visible hide-scrollbar">
              <div role="tablist" className="-mb-px flex gap-4">
                {days.map((day) => (
                  <button
                    key={day.id}
                    onClick={() => setSelectedDay(day.id)}
                    className={`flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 ${
                      selectedDay === day.id
                        ? "border-blue-600 text-blue-600"
                        : "border-transparent text-gray-600"
                    }`}
                  >
                    <CalendarIcon />
                    <span className="font-bold">
                      Day {day.day_number}
                    </span> – {day.topic}
                  </button>
                ))}
              </div>
            </div>

            <div role="tabpanel" className="mt-4 mb-4 px-4">
              <div className="space-y-4">
                {activeDay?.sessions?.map((group) => (
                  <details
                    key={group.id}
                    className="group [&amp;_summary::-webkit-details-marker]:hidden"
                  >
                    <summary className="flex cursor-pointer items-center justify-between gap-4 rounded-lg border border-gray-200 bg-[#0166b1] px-4 py-3 font-medium hover:bg-gray-50 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800">
                      <span className="flex items-center gap-4">
                        {group.start_time} -{group.end_time} - {group.title}
                      </span>
                      {group.items.length > 0 && (
                        <svg
                          className="size-5 shrink-0 transition-transform duration-300 group-open:-rotate-180"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      )}
                    </summary>
                    {group.items.length > 0 && (
                      <div className="space-y-2 pl-4">
                        {group.items.map((item, idx) => (
                          <details className="group/members [&amp;_summary::-webkit-details-marker]:hidden">
                            <summary
                              key={idx}
                              className="flex cursor-pointer items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                            >
                              <p>
                                {item.start_time} - {item.end_time}
                              </p>
                              <span className="mt-1 inline-block rounded-full bg-blue-100 px-2 py-0.5 text-xs text-blue-700">
                                {item.title}
                              </span>

                              <svg
                                className="size-4 shrink-0 transition-transform duration-300 group-open/members:-rotate-180"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </summary>
                            <div className="p-4 flex flex-row justify-between">
                              <p className="font-bold">
                                {item.speaker
                                  ? `${item.speaker.first_name} ${item.speaker.last_name}`
                                  : "TBA"}
                              </p>
                              <a
                                href={item.presentation_file}
                                target="_blank"
                                rel="noreferrer"
                                className="text-white mx-auto inline-block bg-blue-600 rounded px-5 py-3 font-medium shadow-sm transition-colors hover:bg-black-700"
                              >
                                View Session Slides
                              </a>
                            </div>
                          </details>
                        ))}
                      </div>
                    )}
                  </details>
                ))}
              </div>
            </div>
          </>
        ) : (
          <EmptyContent
            title="agenda is available"
            description="The Agenda for the workshop is still being made kindly wait for updates."
          />
        )}
      </div>
    </div>
  );
}

export default Agenda;
